import type { TableColumnsType } from "antd";
import { Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSponsorDisbursements } from "../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { scroll, toFormatAmount } from "../../../components/utils/utils";
import CustomConfigProvider from "../ProfileHeader";

const itemPerPage = 8;

const SponsorDisbursements = () => {
  const dispatch = useDispatch<AppDispatch>();

  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const { loading, disbursements, TotalDisbursements } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  useEffect(() => {
    dispatch(
      getSponsorDisbursements({
        sponsor_id: otpId,
        limit: itemPerPage,
        page: currentPage,
      })
    );
  }, [dispatch, otpId, currentPage]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const columns: TableColumnsType<any> = [
    {
      title: "الفترة",
      dataIndex: "period_name",
      render: (text: string) => (
        <b className="takaful--text-color-blue">
          <span>{text}</span>
        </b>
      ),
    },
    {
      title: "عدد المكفولين",
      dataIndex: "beneficiaries_count",
      render: (count: number) => <span>{count ?? 0}</span>,
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      render: (amount: number) => (
        <span>
          {toFormatAmount(amount || 0)}{" "}
          <span className="icon-saudi_riyal"> </span>
        </span>
      ),
    },
    {
      title: "تاريخ الصرف",
      dataIndex: "disbursement_date",
      render: (date: any) => (
        <span className="takaful--font-tajwal">{date ? date : "-"}</span>
      ),
    },
  ];

  return (
    <div className="takaful--sponsor-donation-payment" ref={currentRef}>
      <CustomConfigProvider title="تفاصيل المصروفات"></CustomConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ minHeight: "20vh" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : (
        <>
          <Table<any>
            style={{ direction: "rtl" }}
            columns={columns}
            dataSource={disbursements}
            className="takaful--sponsor-table"
            scroll={{ x: "max-content" }}
            pagination={false}
            locale={{ emptyText: "لا يوجد مصروفات" }}
          />
          {Math.ceil(TotalDisbursements * itemPerPage) > itemPerPage && (
            <PaginationComponent
              active={currentPage}
              total={Math.ceil(TotalDisbursements * itemPerPage)}
              itemPerPage={itemPerPage}
              scroll={() => scroll(currentRef)}
              setActive={(nb) => updateActive(nb)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SponsorDisbursements;
